export default __webpack_public_path__ + "static/media/flag-andorra.7bc36d62.svg";